import { type Dispatch, type SetStateAction, useEffect, useState } from "react";

import input from "../../../../assets/styles/components/input.module.css";
import styles from "./HeaderProducts.module.css";

import { Add, FilterAlt, FilterAltOffSharp, Search, ArrowBack } from "@mui/icons-material";

import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import Button from "../../../../components/Button/Button";
import ModalFilter from "./ModalFilter";
import useStore from "./Values";
import InputSearch from "../../../../components/InputSearch/InputSearch";

type props = {
  search: string;
  setSearch: Dispatch<SetStateAction<string>>;
  cleanDataProducts?: () => void;
  cleanFilters: () => void;
  filterValues: {
    titulo?: string;
    measure?: string;
    typeProduct?: string;
    category?: string;
  };
  setFilterValues: Dispatch<
    SetStateAction<{
      titulo?: string;
      unitMeasure?: string;
      typeProduct?: string;
      category?: string;
    }>
  >;
  qtdProducts: number;
};

const HeaderProducts = (props: props) => {
  const queryClient = useQueryClient();
  const copyProduct = useStore((state) => state.copyProduct);

  const navigate = useNavigate();

  const {
    search,
    setSearch,
    qtdProducts,
    cleanFilters,
    setFilterValues,
    filterValues,
  } = props;

  const [isHidden, setIsHidden] = useState<{
    addProduct: boolean;
    addCategory: boolean;
    filter?: boolean;
    addScaleData?: boolean;
    nutrition?: boolean;
  }>({
    addProduct: true,
    addCategory: true,
    filter: true,
    addScaleData: true,
    nutrition: true,
  });

  useEffect(() => {
    if (copyProduct) {
      setIsHidden((prev) => ({ ...prev, addProduct: false }));
    }
  }, [copyProduct]);

  return (
    <div className={styles.header}>
      <h1>Produtos</h1>
      
      <InputSearch
        searchValue={search}
        setSearchValue={setSearch}
        placeholder="Pesquisar"
      />

      <div className={styles.headerButtons}>
        <p>
          Qtd:<span>{qtdProducts}</span>
        </p>
        <Button
          variant="contain"
          onClick={() => setIsHidden((prev) => ({ ...prev, filter: false }))}
          title="Aplicar filtros">
          <FilterAlt />
        </Button>
        <Button variant="contain" onClick={cleanFilters} title="Limpar filtros">
          <FilterAltOffSharp />
        </Button>
        <Button
          variant="contain"
          onClick={() =>
            navigate("add")
          }
          title="Adicionar produto">
          <Add />
        </Button>
      </div>

      {!isHidden?.filter && (
        <ModalFilter
          setIsHidden={setIsHidden}
          setFilterValues={setFilterValues}
          filterValues={filterValues}
        />
      )}
    </div>
  );
};

export default HeaderProducts;
